import { BlogCta } from "@components";
import "./style.scss";

customElements.define("blog-cta", BlogCta);
